import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {BehaviorSubject} from 'rxjs';

const routes = {
  updateUserSignReceive: '/contract/update-user-sign-receive',
  updateUserSignReceiveLot: '/sign-lot-flow/setup-internal',
  consumptionHistory: '/analysis/consumption'
};

@Injectable({
  providedIn: 'root'
})

export class ContractService {


  constructor(private apiService: ApiService) {
  }

  // Lấy số hợp động của Khách hàng
  getDataCountNumberDocumentforUserService(params?: any) {
    return this.apiService.get('/contract/user-statistic', params)
      .pipe(map(res => {
        return res;
      }));
  }

  // Lấy số HĐ của Doanh nghiệp
  getDataCountNumberDocumentforEnterpriseService() {
    return this.apiService.get('/contract/enterprise')
      .pipe(map(res => {
        return res;
      }));
  }

  // Lấy số HĐ nhận được từ Đối tác
  getDataCountNumberDocumentOfPartnerService(params?: any) {
    return this.apiService.get('/contract/partner', params)
      .pipe(map(res => {
        return res;
      }));
  }

  // Lấy số tài nguyên của Doanh nghiệp mua dịch vụ người dùng hiện tại
  getDataCountNumberDocumentOfEnterpriseByService() {
    return this.apiService.get('/enterprises/enterprise-by-service')
      .pipe(map(res => {
        return res;
      }));
  }
  // Lấy danh sách tiêu chí hđlđ
  getPropertiesForUpdate() {
    return this.apiService.get('/contract-employment/properties-for-update')
      .pipe(map(res => {
        return res;
      }));
  }

  // Lấy số tài nguyên của Doanh nghiệp mua dịch vụ người dùng hiện tại
  getDataSmsContractQuantityByEnterpriseId(enterpriseId: string) {
    return this.apiService.get('/enterprises/enterprise-by-service/' + enterpriseId)
      .pipe(map(res => {
        return res;
      }));
  }

  // update luồng ký nội bộ của bên nhận
  updateUserSignReceive(data) {
    return this.apiService.post(routes.updateUserSignReceive, data)
      .pipe(map(res => {
        return res;
      }));
  }

  // update luồng ký nội bộ của bên nhận cho lô (nhiều HĐ cùng lúc)
  updateUserSignReceiveLot(contractIds: string[], contractUsers: any[]) {
    return this.apiService.post(routes.updateUserSignReceiveLot, {contractIds, contractUsers})
      .pipe(map(res => {
        return res;
      }));
  }

  // Add user apostrophe
  addUserInitial(obj: any) {
    return this.apiService.post('/contract/initial-user', obj)
      .pipe(map(res => {
        return res;
      }));
  }

  // Lấy số chi tiêu SMS, Hợp đồng
  getDataConsumptionHistoryService(consumptionRequest: any) {
    return this.apiService.post(routes.consumptionHistory, consumptionRequest)
      .pipe(map(res => {
        return res;
      }));
  }
  // Lấy danh sách version của HĐLĐ
  getListVersionHistory(id: string) {
    return this.apiService.get(`/contract-employment/get-contract-moha-version/${id}`)
      .pipe(map(res => {
        return res;
      }));
  }

  // Add user signature process
  addUserSignatureProcess(obj: any) {
    return this.apiService.post('/contract/approve-user', obj)
      .pipe(map(res => {
        return res;
      }));
  }

  addLotSignatureProcess(obj: any) {
    return this.apiService.post('/confirm-lot-flow', obj)
      .pipe(map(res => {
        return res;
      }));
  }

  // cancel user signature process
  cancelUserSignatureProcess(obj: any) {
    return this.apiService.post('/contract/cancel-user-approve', obj)
      .pipe(map(res => {
        return res;
      }));
  }

  // Add user forward sign
  addUserForwardSign(obj: any) {
    return this.apiService.post('/contract/forward-sign-contract', obj)
      .pipe(map(res => {
        return res;
      }));
  }

  //Kiem tra BBUQ cua chu the
  checkTindyUser() {
    return this.apiService.get('/users/auth-records/check')
      .pipe(map(res => {
        return res;
      }));
  }
}
